export default function IconPlayClean() {
  return (
    <svg width="20" height="18" viewBox="-3 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.20523 0.449123C1.59043 -0.475991 0.28125 0.281873 0.28125 2.14051V15.8564C0.28125 17.7169 1.59043 18.4738 3.20523 17.5495L15.2086 10.6743C16.824 9.74885 16.824 8.24949 15.2086 7.32427L3.20523 0.449123Z" fill="currentColor" />
    </svg>
  );
}
